<template>
  <div class="notification-container">
    <close-todo-alarm v-if="isCloseTodoAlarmShowed" :alarmData="selectedAlarmData"
                      @closeButtonClicked="isCloseTodoAlarmShowed=false"
                      @alarmClosed="isCloseTodoAlarmShowed=false"></close-todo-alarm>
    <el-tabs v-model="selectedNotificationTabName">
      <!-- eslint-disable-next-line no-irregular-whitespace -->
      <el-tab-pane v-if="!$store.getters.user.isAdmin" :label="`　待办(${notificationData.todoCount})　`"
                   name="todoList">
        <el-scrollbar ref="todoScroll" v-if="notificationData.todoList.length||isInitializing"
                      class="eg-scroll-container" :native="false" :noresize="false" tag="section"
                      v-loading="isInitializing">
          <div class="todo-list-container">
            <ul>
              <li v-for="(item,index) in notificationData.todoList" :key="index"
                  @contextmenu.prevent="showContextMenu(item,$event)">
                <p class="priority-text high"
                   :class="{high:item.level===3,middle:item.level===2,low:item.level===1}">
                  {{item.level===3?'高':item.level===2?'中':'低'}}
                </p>

                <div class="content-container">
                  <p class="content" :title="`【${item.name}】${item.content}`">
                    【{{item.name}}】{{item.content}}</p>
                  <p class="date-time">
                    {{dateFormat(item.alarmTime, 'MM月dd日 hh:mm:ss')}}&emsp;
                    <span v-if="item.type !== 3" @click="detailsClicked(item)">详情>></span>&emsp;&emsp;
                    <span @click="closeTodoButtonClicked(item)">关闭</span>
                  </p>
                </div>
              </li>
              <li v-loading="isLoadingMoreTodoList">
                <div v-if="notificationData.todoCount>notificationData.todoList.length"
                     class="more-button" @click="moreTodoButtonClicked">显示更多
                </div>
                <div v-else class="no-more">到底啦~</div>
              </li>
            </ul>
          </div>
        </el-scrollbar>
        <div v-else class="empty-container">
          <img src="@/assets/images/notification/bell.png" alt="">
          <p>暂无通知</p>
        </div>
      </el-tab-pane>
      <!-- eslint-disable-next-line no-irregular-whitespace -->
      <el-tab-pane :label="`　通知(${notificationData.messageUnreadCount})　`" name="messageList">
        <el-scrollbar v-if="notificationData.messageList.length||isInitializing"
                      class="eg-scroll-container" :native="false" :noresize="false" tag="section"
                      v-loading="isInitializing||isReadingAllMessages">
          <div class="message-list-container">
            <div class="read-button" @click="allMessageReadButtonClicked">标记全部已读</div>
            <ul>
              <li v-for="(item,index) in notificationData.messageList" :key="index"
                  :class="{read:item.isRead}" @click="messageCellClicked(item)"
                  v-loading="item.isReading">
                <div class="content-container">
                  <p class="content" :title="item.message">{{item.message}}</p>
                  <p class="date-time">{{dateFormat(item.createTime, 'MM月dd日 hh:mm:ss')}}</p>
                </div>
                <i v-show="item.type===1" class="el-icon-arrow-right"></i>
              </li>
              <li v-loading="isLoadingMoreMessageList">
                <div v-if="notificationData.messageCount>notificationData.messageList.length"
                     class="more-button" @click="moreMessageButtonClicked">显示更多
                </div>
                <div v-else class="no-more">到底啦~</div>
              </li>
            </ul>
          </div>
        </el-scrollbar>
        <div v-else class="empty-container">
          <img src="@/assets/images/notification/bell.png" alt="">
          <p>暂无通知</p>
        </div>
      </el-tab-pane>
    </el-tabs>
    <i class="el-icon-close" @click="$emit('closeButtonClicked')"></i>
    <div v-show="isContextMenuShow" class="context-menu-container" :style="contextMenuStyle"
         @click.stop="menuClicked">
      关闭
    </div>
  </div>
</template>
<script>
import closeTodoAlarm from './closeTodoAlarm'
import Tools from '@/utils/Tools/index'

export default {
  name: 'notificationPanel',
  components: {
    closeTodoAlarm
  },
  data () {
    return {
      selectedNotificationTabName: this.$store.getters.user.isAdmin ? 'messageList' : 'todoList',
      isInitializing: false,
      isLoadingMoreTodoList: false,
      isLoadingMoreMessageList: false,
      notificationData: this.$store.getters.notification,
      isContextMenuShow: false,
      contextMenuStyle: {
        right: '0',
        bottom: '0'
      },
      isCloseTodoAlarmShowed: false,
      selectedAlarmData: null,
      isReadingAllMessages: false,
      checkIntervalId: null
    }
  },
  methods: {
    detailsClicked (data) {
      if (data.type === 1) {
        this.$router.push({ name: 'alarmQuery' })
      } else if (data.type === 2 && this.$route.name !== 'securityManageProject') {
        this.$router.push({
          name: 'securityManageProject'
        })
      } else {
        // sonar规则校验语法必须else
      }
      this.$store.commit('SET_TAB', 'second')
    },
    dateFormat: Tools.dateFormat,
    async closeTodoButtonClicked (todoData) {
      const formData = {
        id: todoData.id
      }
      await this.$store.dispatch('CloseTodoAlarm', formData)
      this.$message({ message: '关闭成功', type: 'success', showClose: true })
    },
    showContextMenu (todoData, event) {
      this.contextMenuStyle.right = `${
        document.body.clientWidth - event.pageX - 106
      }px`
      this.contextMenuStyle.bottom = `${
        document.body.clientHeight - event.pageY - 40
      }px`
      this.isContextMenuShow = true
      this.selectedAlarmData = todoData
    },
    hideContextMenu () {
      this.isContextMenuShow = false
    },
    menuClicked () {
      this.isCloseTodoAlarmShowed = true
    },
    async moreTodoButtonClicked () {
      this.isLoadingMoreTodoList = true
      try {
        await this.$store.dispatch('GetMoreTodoList')
      } catch (e) {
        console.log(e)
      }
      this.isLoadingMoreTodoList = false
    },
    async allMessageReadButtonClicked () {
      const messageIds = []
      for (const messageData of this.notificationData.messageList) {
        if (!messageData.isRead) {
          messageIds.push(messageData.id)
        }
      }
      if (messageIds.length === 0) {
        return
      }
      this.isReadingAllMessages = true
      try {
        await this.$store.dispatch('ReadMessages', messageIds)
      } catch (e) {
        console.log(e)
      }
      this.isReadingAllMessages = false
    },
    async messageCellClicked (messageData) {
      this.$set(messageData, 'isReading', true)
      try {
        if (!messageData.isRead) {
          await this.$store.dispatch('ReadMessages', [messageData.id])
        }
        if (messageData.type === 1) {
          this.$router.push({ path: '/main/personRenew' })
          this.$emit('closeButtonClicked')
        }
      } catch (e) {
        console.log(e)
      }
      this.$set(messageData, 'isReading', false)
    },
    async moreMessageButtonClicked () {
      this.isLoadingMoreMessageList = true
      try {
        await this.$store.dispatch('GetMoreMessageList')
      } catch (e) {
        console.log(e)
      }
      this.isLoadingMoreMessageList = false
    },
    async initData () {
      this.isInitializing = true
      try {
        await this.$store.dispatch('InitNotificationData', this.$store.getters.user.isAdmin ? 0 : this.$store.getters.user.selectedProject.id)
        if (this.$store.getters.user.isAdmin) {
          this.checkIntervalId = setInterval(() => {
            this.$store.dispatch('CheckMessageList')
          }, 30000)
        }
        this.isInitializing = false
      } catch (e) {
        console.log(e)
      }
    }
  },
  created () {
    this.initData()
  },
  mounted () {
    document.body.addEventListener('click', this.hideContextMenu)
    this.$refs.todoScroll && this.$refs.todoScroll.$el.getElementsByClassName('el-scrollbar__wrap')[0].addEventListener('scroll', this.hideContextMenu)
  },
  beforeDestroy () {
    document.body.removeEventListener('click', this.hideContextMenu)
    this.checkIntervalId && clearInterval(this.checkIntervalId)
  }
}
</script>
<style lang="less" scoped>
.notification-container {
  position: absolute;
  top: 64px;
  left: 100%;
  bottom: 0;
  width: 350px;
  box-shadow: -1px 0 0 0 #dddfe7;
  background-color: #ffffff;
  z-index: 10;
  transform: translateX(0);
  transition: transform 200ms;
  &.showed {
    transform: translateX(-100%);
  }
  /deep/ .el-tabs {
    display: flex;
    flex-direction: column;
    height: 100%;
    > .el-tabs__header {
      margin: 0;
      > .el-tabs__nav-wrap {
        &::after {
          height: 1px;
          background-color: #e8e8e8;
        }
        > .el-tabs__nav-scroll {
          padding: 0 16px;
          .el-tabs__active-bar {
            background-color: #5c8ec8;
          }
          .el-tabs__item {
            height: 46px;
            font-size: 14px;
            line-height: 44px;
            font-weight: 500;
            color: #000000;
            &.is-active {
              color: #5c8ec8;
            }
          }
        }
      }
    }
    > .el-tabs__content {
      flex: 1;
      > .el-tab-pane {
        position: relative;
        height: 100%;
        > .eg-scroll-container {
          height: 100%;
        }
      }
    }
  }
  > i.el-icon-close {
    position: absolute;
    top: 12px;
    right: 12px;
    font-size: 18px;
    color: #979799;
    cursor: pointer;
  }
  > .context-menu-container {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 106px;
    height: 40px;
    padding: 0 16px;
    background-color: #ffffff;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
    border-radius: 5px;
    border: 1px solid #dbdbdb;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    line-height: 38px;
    cursor: pointer;
  }
  .todo-list-container {
    > ul {
      padding: 8px 0;
      > li {
        padding: 8px 16px;
        > .priority-text {
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          float: left;
          &.high {
            color: #ff7369;
          }
          &.middle {
            color: #eeb924;
          }
          &.low {
            color: #30beac;
          }
        }
        > .content-container {
          margin-left: 16px;
          > .content {
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            line-height: 20px;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          > .date-time {
            margin-top: 6px;
            font-size: 12px;
            font-weight: 400;
            color: #c0c4cc;
            line-height: 17px;
            > span {
              display: none;
              font-size: 12px;
              font-weight: 400;
              color: #5c8ec8;
              line-height: 17px;
              cursor: pointer;
            }
          }
        }
        > .more-button {
          margin-left: 16px;
          font-size: 14px;
          font-weight: 400;
          color: #6e9dd4;
          line-height: 20px;
          cursor: pointer;
        }
        > .no-more {
          margin-left: 16px;
          font-size: 14px;
          font-weight: 400;
          color: #979799;
          line-height: 20px;
        }
        &:hover {
          background-color: #f7f7f7;
          > .content-container {
            > .date-time {
              > span {
                display: inline;
              }
            }
          }
        }
      }
    }
  }
  .message-list-container {
    > .read-button {
      margin-top: 16px;
      padding: 0 16px;
      font-size: 12px;
      font-weight: 400;
      color: #666666;
      line-height: 17px;
      cursor: pointer;
    }
    > ul {
      margin-top: 12px;
      > li {
        position: relative;
        padding: 8px 16px;
        cursor: pointer;
        > .content-container {
          margin-right: 20px;
          > .content {
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            line-height: 20px;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          > .date-time {
            margin-top: 6px;
            font-size: 12px;
            font-weight: 400;
            color: #c0c4cc;
            line-height: 17px;
            > span {
              display: none;
              font-size: 12px;
              font-weight: 400;
              color: #5c8ec8;
              line-height: 17px;
              cursor: pointer;
            }
          }
        }
        > i.el-icon-arrow-right {
          position: absolute;
          top: 50%;
          right: 20px;
          font-size: 14px;
          color: #c0c4cc;
          line-height: 20px;
          transform: translateY(-50%);
        }
        > .more-button {
          font-size: 14px;
          font-weight: 400;
          color: #6e9dd4;
          line-height: 20px;
          cursor: pointer;
        }
        > .no-more {
          font-size: 14px;
          font-weight: 400;
          color: #979799;
          line-height: 20px;
        }
        &:hover {
          background-color: #f7f7f7;
          > .content-container {
            > .date-time {
              > span {
                display: inline;
              }
            }
          }
        }
        &.read {
          > .content-container {
            > .content {
              color: #b2b5bd;
            }
          }
        }
      }
    }
  }
  .empty-container {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    > img {
      display: block;
      margin: auto;
      width: 76px;
    }
    > p {
      margin-top: 16px;
      font-size: 14px;
      font-weight: 400;
      color: #000000;
      line-height: 21px;
      text-align: center;
      opacity: 0.45;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/notification/notificationPanel.vue